module.exports = __webpack_public_path__ + "static/media/pores.1c332a2c.svg";